module.exports = __webpack_public_path__ + "static/media/balancer.c7b11ae5.svg";